<!--
 * @Author: cgh
 * @Date: 2022-07-29 14:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:01:33
 * @Description: 操作指引
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="操作指引"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      配电箱有明显的区分标志
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CzzyDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面是否加载
      /* 表单参数 Start */
      fd: {

      }

    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }

  },
  created () {
    // this.$nextTick(() => {
    // this.fd.id = this.dlParams.id;
    // this.initial();
    // });
    //
  }
};

</script>
